import React from "react";
import { Helmet } from "react-helmet";
import { HeroContainer } from "../../assets/styles/theme/styles";
import CommonDiv1 from "../../shared/CommonDiv1";
import ThreeCards from "../../shared/ThreeCards";
import IMAGES from "../../Images";
import GridTextContainer from "../../shared/GridTextContainer";
import GridResPonsiveCards from "../ml-assistant/components/GridResPonsiveCards";
import VoiceDiv3 from "../../shared/VoiceDiv3";
import CardSection from "../../shared/CardSection";
import WhatsappDiv6 from "../../shared/WhatsappDiv6";

export default function ContactCenterSuite() {
  const helpItems = [
    {
      title: `Excellent 
      customer experience`,
      description: `Enable a connected and consistent 
      experience across all touchpoints.
      Seamlessly connect digital channels 
      to provide the same level of service 
      no matter how customers get in touch.
      Reduce wait times and transfers 
      between agents. Provide agents with all 
      the customer history and context they 
      need to resolve issues quickly
      Communications Limited.`,
      image: `${IMAGES.contactcenterc1}`,
    },
    {
      title: `Optimize agent 
      performance`,
      description: `Access all communication channels 
      from a single omnichannel interface.
      All contextual information and customer 
      data instantly available. Take the strain 
      off agents with self-service chatbots.
      Native support for hybrid working with 
      no loss of agent productivity.`,
      image: `${IMAGES.contactcenterc2}`,
    },
    {
      title: `Maximize contact 
      center efficiency`,
      description: `The simplicity of a single solution provider 
      for all channels. Benefit from the reduced 
      cost and easy scalability of digital channels.
      Drive continuous improvement with access 
      to key metrics and insights. Leverage the strengths 
      of AI to make human agents more efficient.`,
      image: `${IMAGES.contactcenterc3}`,
    },
  ];

  const helpContent = [
    {
      title: `Call Tracking and Analytics`,
      description: `Features like CSAT score, call tracking and recording can be very useful tools in addition to track AHT of agents to understand the team performance. Tubelight offers 70+ custom reports to address agents to admin use cases.`,
    },
    {
      title: `ACD Intelligent Routing`,
      description: `Advanced Automatic Call Distributor (ACD) systems can route calls based on skill, location, language like feature to route the call to the right agent. Attribute-based routing and priority-based routing are examples of intelligent routing. `,
    },
    {
      title: `Reliability`,
      description: `Enterprise-level reliability with better uptime and speed improvements through software upgrades. Tens of thousands of customers' needs are combined by cloud-based contact centers, which provides more reliability than what the majority of firms can afford to deploy on their own.`,
    },
  ];
  const cards = [
    {
      title: `Features`,
      body: [
        ` IVR Designer`,
        ` Skill & Campaign`,
        ` Fall Backs`,
        ` Time Based`,
        ` Agent Priority Based`,
        ` Queue Size & Timeouts`,
        ` Integrated with CRM`,
      ],
    },
    {
      title: `WebRTC Softphone`,
      body: [
        ` Hold & Mute`,
        ` Transfer - 3 Types`,
        ` Conference - 3 Types`,
        ` CRM pop up`,
        ` Campaign name`,
        ` Mode Change - Inbound, Outbound, Dialer`,
      ],
    },
    {
      title: `Live Monitoring and Dashboard`,
      body: [
        ` Live monitoring`,
        ` Dashboard`,
        ` CDR Reports`,
        ` Editable Reports`,
        ` Agent Performance & user summary reports`,
      ],
    },
  ];

  const arrayData = [
    ` Drag and drop Based IVR flow creation`,
    ` Easy to configure flow`,
    ` Multi-level IVR Technology`,
    ` API integration in IVR Flow : Collect DTMF Responses, SET dynamic flows, Broadcast OBD Personalized / Responsive`,
    ` Call Forwarding`,
    ` Text to speech available to create voice files in major Global / Regional Language.`,
  ];

  const arrayData2 = [
    {
      icon: IMAGES.flywoman,
      heading: "Campaigner",
      paragraph:
        "Target your customers by automating and designing your intelligent campaign strategy on their preferred channels.",
      linkname: "Learn more",
      linkref: `/campaigns`,
    },
    {
      icon: IMAGES.thinkwoman,
      heading: "1iNbox",
      paragraph:
        "Omnichannel, one shared inbox. find and share information collaborate, and resolve customer queries faster.",
      linkname: "Learn more",
      linkref: `/1iNbox`,
    },
  ];

  const data = [
    `Tubelight programmable API infrastructure
    enables developers to easily integrate communication API’s and create solutions
    of their choice. Create a free developer account today to access API and SDK’s.`,
  ];
  return (
    <>
      <Helmet>
        <title>
          Contact Center Suite: Deliver Personalized, Omnichannel Support
        </title>
        <meta
          name="description"
          content="Connect with customers seamlessly across all channels with Tubelight's contact center suite. Enhance customer interactions with interactive voice response services."
        />
        <meta
          name="keywords"
          content="contact center suite, interactive voice response services
          "
        ></meta>
      </Helmet>
      <HeroContainer imageUrl={IMAGES.smsbgdiv1} ht="1200px" bgSize="cover">
        <CommonDiv1
          title={`Cloud Contact Suite built for better CX`}
          description={`Provide a personalized customer experience, 
          and empower agents to perform at their best 
          with a cloud contact center suite that supports 
          engagement on all the channels your 
          customers use.`}
          fgimage={IMAGES.contactcenterfg1}
          btns={["Try for Free", "Talk to Expert"]}
        />
        <ThreeCards
          title="Omni Channel, enagement for teams & agents "
          titleDes={`Deploy best in class contact center solution at scale with tons of loaded feature & a great UI for better productivity & customer support.`}
          subtitle="Excellent 
          customer experience"
          description="Enable a connected and consistent 
          experience across all touchpoints.
          Seamlessly connect digital channels 
          to provide the same level of service 
          no matter how customers get in touch.
          Reduce wait times and transfers 
          between agents. Provide agents with all 
          the customer history and context they 
          need to resolve issues quickly
          Communications Limited."
          helpItems={helpItems}
        />
      </HeroContainer>
      <HeroContainer imageUrl={IMAGES.bg3}>
        <GridTextContainer
          heading="Contact Center Suite"
          helpContent={helpContent}
        />
        <GridResPonsiveCards heading={`Highlight`} cards={cards} />
      </HeroContainer>

      <HeroContainer imageUrl={IMAGES.bg3}>
        <VoiceDiv3
          heading={`Flow Builder`}
          text={arrayData}
          image={IMAGES.flowbfg1}
          linkname={`learn more`}
          linkref={`/flow-builder`}
        />
        <CardSection heading={`Explore more products`} data={arrayData2} />
      </HeroContainer>
      <HeroContainer imageUrl={IMAGES.bg4}>
        <WhatsappDiv6
          heading={`For
            Developers, By Developers`}
          data={data}
        />
      </HeroContainer>
    </>
  );
}
